"use client";

import styled from "styled-components";
import WarningIcon from "@/assets/icons/WarningIcon.svg";
import Button from "../Button/Button";
import { useTranslations } from "next-intl";
import { Icon } from "../Icon/Icon";
import theme from "@/themes/velys-theme";
import { useMedia } from "@/lib/hooks/useMedia";

const DeletePasskey = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 15px;

  h2 {
    font-weight: normal;
    font-size: 2rem;
    text-align: center;
  }

  p {
    text-align: center;
  }

  .footer {
    margin-top: 20px;
    display: flex;
    justify-content: flex-end;
    gap: 15px;
    width: 100%;
  }

  @media (max-width: 425px) {
    gap: 10px;

    h2 {
      font-size: 1.5rem;
    }

    p {
      font-size: 0.9rem;
    }

    .footer {
      gap: 10px;
      margin-top: 15px;
    }
  }
`;

type DeletePasskeyContentProps = {
  onCancel: () => void;
  onConfirm: () => void;
  isDeleting: boolean;
};

export function DeletePasskeyContent({
  onCancel,
  onConfirm,
  isDeleting,
}: DeletePasskeyContentProps) {
  const tProfile = useTranslations("profilePage");
  const tComponents = useTranslations("componentText");
  const max425w = useMedia("(max-width: 425px)");

  return (
    <DeletePasskey>
      <Icon
        url={WarningIcon.src}
        color="#ACACAC"
        height={max425w ? "48px" : "65px"}
        width={max425w ? "48px" : "65px"}
      />
      <h2 className="johnson-display">{tProfile("removePasskeyTitle")}</h2>
      <p>
        {tProfile.rich("removePasskeyBody", {
          bold: (chunks) => <strong>{chunks}</strong>,
        })}
      </p>
      <div className="footer">
        <Button
          label={tComponents("cancel")}
          theme="tertiary"
          name="cancel-delete-passkey"
          onPress={onCancel}
          isDisabled={isDeleting}
        />
        <Button
          icon={isDeleting ? "loader" : undefined}
          label={tComponents("delete")}
          theme="primary"
          name="confirm-delete-passkey"
          onPress={onConfirm}
          isDisabled={isDeleting}
          iconColor={theme.white}
        />
      </div>
    </DeletePasskey>
  );
}
